class PandasEvent {
  /** @deprecated Use PanelEvent.OPEN */
  static OPEN = 'PandasEvent.OPEN';

  /** @deprecated Use PanelEvent.CLOSE */
  static CLOSE = 'PandasEvent.CLOSE';
}

export default PandasEvent;
